/**
 * The menu categories (~1200, read-only on the client) are frozen before the SSR state is
 * hydrated, so Vue doesn't make each one reactive and the components that scan the list
 * (menu, product tiles, search) don't track a dependency per category property.
 * The array itself stays reactive, so categories added later still show up.
 */
export const freezeMenuCategories = (state) => {
  const menuCategories = state && state['category-next'] && state['category-next'].menuCategories

  if (Array.isArray(menuCategories)) {
    menuCategories.forEach(category => Object.freeze(category))
  }

  return state
}
